var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64645 0.146447C7.84171 -0.0488155 8.15829 -0.0488155 8.35355 0.146447L12.5202 4.31311C12.7155 4.50838 12.7155 4.82496 12.5202 5.02022C12.325 5.21548 12.0084 5.21548 11.8131 5.02022L8.5 1.70711V10.5C8.5 10.7761 8.27614 11 8 11C7.72386 11 7.5 10.7761 7.5 10.5V1.70711L4.18689 5.02022C3.99162 5.21548 3.67504 5.21548 3.47978 5.02022C3.28452 4.82496 3.28452 4.50838 3.47978 4.31311L7.64645 0.146447ZM0.5 10C0.776142 10 1 10.2239 1 10.5V13.8333C1 14.1428 1.12292 14.4395 1.34171 14.6583C1.5605 14.8771 1.85725 15 2.16667 15H13.8333C14.1428 15 14.4395 14.8771 14.6583 14.6583C14.8771 14.4395 15 14.1428 15 13.8333V10.5C15 10.2239 15.2239 10 15.5 10C15.7761 10 16 10.2239 16 10.5V13.8333C16 14.408 15.7717 14.9591 15.3654 15.3654C14.9591 15.7717 14.408 16 13.8333 16H2.16667C1.59203 16 1.04093 15.7717 0.634602 15.3654C0.228273 14.9591 0 14.408 0 13.8333V10.5C0 10.2239 0.223858 10 0.5 10Z",
    fill: "gray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIconGray);
export default __webpack_public_path__ + "static/media/uploadIconGray.9efd305a51774be8d5e42cfd9806f424.svg";
export { ForwardRef as ReactComponent };